import Vue from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import careHelpfulFunctions from '../../careHelpfulFunctions.jsx';
import { appSettings } from '@/Shared/appSettings.js';
import DropdownMultiSelectBase from '../vuecontrols/DropdownMultiSelectBase';

Vue.component('sform-dropdownmultiselect', {
    mixins: [BaseComponent],
    data: () => ({
        dolookupexpn: null,
        lookupurlexpn: null,
        lookuprawexpn: null,

        displayexpnfunc: null,
        valueexpnfunc: null,

        item_text: null,
        item_value: null,
        lookupitems: [],

        includeEmpty: false,
        emptyLabelexpn: null,
        emptySelected: false,
        initialEmptyValue: false,
    }),
    components: {
        DropdownMultiSelectBase
    },
    props: {
    },
    created() {
        if (this.element.schema && this.element.schema.formatData) {
            const formatData = this.element.schema.formatData;

            if (formatData.LookupExpression)
                this.dolookupexpn = utils.compileExpression(this, formatData.LookupExpression);

            if ((!formatData.LookupType || formatData.LookupType == 'URL') && formatData.LookupURL)
                this.lookupurlexpn = utils.compile(this, formatData.LookupURL);
            else if (formatData.LookupType == 'Interpolated' && formatData.LookupInterpolatedExpression)
                this.lookuprawexpn = utils.compileExpression(this, formatData.LookupInterpolatedExpression);

            if (formatData.DisplayType == 'Expression') {
                const expr = utils.parseExpressionWithFilters(formatData.DisplayExpression);
                this.displayexpnfunc = {
                    code: expr,
                    func: new Function('control', 'util', formatData.LookupModelAs, `with (control) return ${expr};`)
                };
            }
            if (formatData.ValueType == 'Expression') {
                const expr = utils.parseExpressionWithFilters(formatData.ValueExpression);
                this.valueexpnfunc = {
                    code: expr,
                    func: new Function('control', 'util', formatData.LookupModelAs, `with (control) return ${expr};`)
                };
            }

            switch (formatData.DisplayType) {
                case 'Fieldname': this.item_text = formatData.DisplayField; break;
                case 'Expression':
                    this.item_text = (data) => {
                        try {
                            return this.displayexpnfunc.func(this, careHelpfulFunctions, data);
                        }
                        catch (e) {
                            utils.warn(`DropdownMutltiSelect DisplayType Expression failed to evaluate: ${this.displayexpnfunc.code}; original: ${formatData.DisplayExpression}`, e);
                            return '';
                        }
                    };
                    break;
            }
            switch (formatData.ValueType) {
                case 'Fieldname': this.item_value = formatData.ValueField; break;
                case 'Expression':
                    this.item_value = (data) => {
                        try {
                            return this.valueexpnfunc.func(this, careHelpfulFunctions, data);
                        }
                        catch (e) {
                            utils.warn(`DropdownMutltiSelect ValueType Expression failed to evaluate: ${this.valueexpnfunc.code}; original: ${formatData.ValueExpression}`, e);
                            return '';
                        }
                    };
                    break;
            }

            this.includeEmpty = !!formatData.IncludeEmptyItem;
            if (formatData.IncludeEmptyItem && formatData.EmptyItemLabel) {
                this.emptyLabelexpn = utils.compile(this, formatData.EmptyItemLabel);
            }

            if (this.itemvalue && this.includeEmpty)
                this.initialEmptyValue = this.itemvalue.some(a => a === null);
        }

        // Using a manual watch to avoid having the watch function called immediately

        if (this.lookupurlexpn)
            this.lookupurl_watch$ = this.$watch(
                function () {
                    return this.lookupurl;
                },
                function (newval, oldval) {
                    this.Refresh();
                }
            );

        if (this.lookuprawexpn)
            this.lookupraw_watch$ = this.$watch(
                function () {
                    return this.lookupraw;
                },
                function (newval, oldval) {
                    this.Refresh();
                }
            );
    },
    destroyed() {
        if (this.lookupurl_watch$)
            this.lookupurl_watch$();

        if (this.lookupraw_watch$)
            this.lookupraw_watch$();
    },
    computed: {
        tolookup: function () {
            if (this.dolookupexpn)
                return utils.evaluate(this.dolookupexpn, this);
            else
                return true;
        },
        lookupurl: function () {
            if (this.lookupurlexpn)
                try {
                    return utils.evaluate(this.lookupurlexpn, this, false, null, true);
                }
                catch (e) {
                    utils.warn(`DropdownMutltiSelect lookupurl could not be evaluated: ${this.lookupurlexpn.code}`, e);
                    return '';
                }
            else
                return '';
        },
        lookupraw: function () {
            if (this.lookuprawexpn)
                try {
                    return utils.evaluate(this.lookuprawexpn, this, false, null, true);
                }
                catch (e) {
                    utils.warn(`DropdownMutltiSelect lookupraw could not be evaluated: ${this.lookuprawexpn.code}`, e);
                    return [];
                }
            else
                return '';
        },
        emptyLabel: function () {
            if (this.emptyLabelexpn)
                try {
                    return utils.evaluate(this.emptyLabelexpn, this, false, null, true);
                }
                catch (e) {
                    utils.warn(`DropdownMutltiSelect emptyLabelexpn could not be evaluated: ${this.emptyLabelexpn.code}`, e);
                    return '';
                }
            else
                return '';
        },
        itemvalue_noempty: function () {
            let items;
            if (this.includeEmpty)
                items = this.itemvalue.filter(a => a !== null);
            else
                items = this.itemvalue;

            console.log(`formDropdownMultiSelect ${this.name} reading itemvalue_noempty:${JSON.stringify(items)}`);

            return items;
        },
    },
    async mounted() {
        await this.Refresh();
        this.loadComplete();
    },
    methods: {
        async Refresh() {
            if (this.tolookup) {
                if (this.lookupurlexpn) {
                    let url = this.lookupurl;
                    if (url)
                        this.lookupitems = await utils.api.get(url, false, this.element.schema ? this.element.schema.formatData.CacheLookupResult : true);
                }
                else if (this.lookuprawexpn) {
                    this.lookupitems = this.lookupraw;
                }
            }
        },
        updateValue(value) {
            let v = value;
            if (this.includeEmpty && Array.isArray(value))
            {
                if (this.emptySelected)
                    v = [...new Set([null, ...value])]; // Ensure we don't duplicate the empty value
                else
                    v = value.filter(a => a !== null);
            }
            else
                v = value;

            this.sync(v);

            console.log(`formDropdownMultiSelect ${this.name} updateValue:${JSON.stringify(value)} to ${JSON.stringify(v)}`);
        },
        updateEmpty(value) {
            console.log(`formDropdownMultiSelect ${this.name} updateEmpty:${value}`);

            this.emptySelected = value;
            this.updateValue(this.itemvalue);
        },
    },
    render() {
        let slots = [
            <translation-container slot="label" context={this} value={this.labelText}></translation-container>,
        ];

        // 5/19/2025 Jeff Eardley: Me and Robbie looked at translating the menu items here but it caused some concerns. The untranslated items would still exist but were no longer available to deselect
        const items = this.lookupitems || [];

        let input = (
            <DropdownMultiSelectBase
                class="ma-0"
                nameField={this.item_text}
                valueField={this.item_value}
                ccmodel={this.itemvalue_noempty}
                on-input={(value) => this.updateValue(value)}
                on-empty={(value) => this.updateEmpty(value)}
                on-blur={this.onBlur}
                on-focus={this.onFocus}
                hint={this.hintText}
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
                source={items}
                selectionLimit={this.element.formatData?.SelectionLimit || this.element.schema?.formatData?.SelectionLimit}
                showCheckAll={this.element.formatData?.ShowCheckAll || this.element.schema?.formatData?.ShowCheckAll}
                showUncheckAll={this.element.formatData?.ShowUncheckAll || this.element.schema?.formatData?.ShowUncheckAll}
                dynamicButtonText={this.element.formatData?.DynamicButtonText || this.element.schema?.formatData?.DynamicButtonText}
                dynamicItemCount={this.element.formatData?.DynamicItemCount || this.element.schema?.formatData?.DynamicItemCount}
                includeEmpty={this.includeEmpty}
                emptyLabel={this.emptyLabel}
                initialEmptyValue={this.initialEmptyValue}
            >{slots}</DropdownMultiSelectBase>
        );

        if (this.appearance)
            input.componentOptions.propsData = { ...input.componentOptions.propsData, ...this.appearance };

        if (this.directives) {
            if (input.data.directives)
                input.data.directives = [...input.data.directives, ...this.directives];
            else
                input.data.directives = this.directives;
        }

        return input;
    }
});